
import request from '../../utils/request'
import server from './config'
export default {
  getConponDetail:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientCoupon/${params.id}`,
      method: 'get',
      params
    })
  },
  getConponGoodsDetail:(params)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/product/${params.id}`,
      method: 'get',
      params
    })
  },
  getList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/product/getPageList`,
      method: 'post',
      data
    })
  },
  exchange:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientCoupon/exchange`,
      method: 'post',
      data
    })
  },
  getPatientConponList:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/patientCoupon/getPageList`,
      method: 'post',
      data
    })
  },
  hasAvailableCoupon:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/service/agg/order/1/hasAvailableCoupon`,
      method: 'post',
      data
    })
  },
  getProductByPoint:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/online/patient/1/product/getProductByPoint`,
      method: 'post',
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/modules/conpon.js